import { render, staticRenderFns } from "./grade2_demo.vue?vue&type=template&id=13b89f71"
import script from "./grade2_demo.vue?vue&type=script&lang=js"
export * from "./grade2_demo.vue?vue&type=script&lang=js"
import style0 from "./grade2_demo.vue?vue&type=style&index=0&id=13b89f71&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports